import { Component, OnInit, Input } from '@angular/core';
import { Validators, FormGroup } from '@angular/forms';
import { CheckEmailDuplicateByNameRequest, EventInfoWithConsentResponse, CountryResponse, InvestorCompanyResponse, InstitutionalInvestorTypeResponse, RegisterInvestorPublicControllerService, InstitutionalInvestorTypeControllerService } from '@ent-regis/entregis-ts-angular';
import { CountryISO, SearchCountryField } from 'ngx-intl-tel-input';
import { FormUtilsService } from 'src/app/shared/services/form-utils.service';

@Component({
  selector: 'app-investor-profile-section',
  templateUrl: './investor-profile-section.component.html',
  styleUrls: ['./investor-profile-section.component.scss']
})
export class InvestorProfileSectionComponent implements OnInit {

  @Input() profileForm!: FormGroup;
  @Input() lastEmail: string = '';
  @Input() eventInfoWithConsent: EventInfoWithConsentResponse;
  @Input() eventAlias: string = '';
  @Input() companies: InvestorCompanyResponse[] = [];
  @Input() countries: CountryResponse[] = [];

  preferredCountries: CountryISO[] = [CountryISO.Thailand];
  countryISO = CountryISO;
  searchCountryField = [SearchCountryField.Iso2, SearchCountryField.Name];

  institutionalInvestorTypes: InstitutionalInvestorTypeResponse[] = [];

  get f() { return this.profileForm.controls; }

  get isReady(): boolean {
    return !!this.profileForm && !!this.eventAlias;
  }

  constructor(
    private registerInvestorControllerService: RegisterInvestorPublicControllerService,
    private institutionalInvestorTypeControllerService: InstitutionalInvestorTypeControllerService,
    private formUtils: FormUtilsService,
  ) { }

  ngOnInit() {
    this.f.institutionalInvestorTypeId.valueChanges.subscribe(() => {
      this.updateOtherInstitutionalInvestorTypeValidation();
    });

    this.updateOtherInstitutionalInvestorTypeValidation();

    this.institutionalInvestorTypeControllerService.getInstitutionalInvestorTypeUsingGET()
      .subscribe((res) => {
        this.institutionalInvestorTypes = res.data;
      }
    );
  }

  onBlurCheckEmailDuplicate(controlName: string): void {
    const control = this.profileForm.get(controlName);
    const value = control.value;
    if (!value) {
      return;
    }

    if (this.lastEmail && value === this.lastEmail) {
      this.formUtils.removeError(control, 'alreadyUsed');
      return;
    }

    const request: CheckEmailDuplicateByNameRequest = {
      email: value,
      eventAlias: this.eventAlias,
    };

    this.registerInvestorControllerService.checkRegisterEmailDuplicateUsingPOST1(request)
      .subscribe((isAlreadyUsed) => {
        if (isAlreadyUsed.data) {
          this.formUtils.setError(control, 'alreadyUsed', isAlreadyUsed.data);
        } else {
          this.formUtils.removeError(control, 'alreadyUsed');
        }
      });
  }

  isOtherInstitutionalInvestorTypeSelected(): boolean {
    return Number(this.f.institutionalInvestorTypeId.value) === 8;
  }

  private updateOtherInstitutionalInvestorTypeValidation(): void {
    if (this.isOtherInstitutionalInvestorTypeSelected()) {
      this.f.otherInstitutionalInvestorType.setValidators(Validators.required);
    } else {
      this.f.otherInstitutionalInvestorType.reset();
      this.f.otherInstitutionalInvestorType.clearValidators();
    }

    this.f.otherInstitutionalInvestorType.updateValueAndValidity();
  }


}
